(() => {
  const main = document.querySelector('#MainContent[data-template^="product"]');
  if (!main || main.dataset.template === 'product.combo-bomba-de-vacio' || main.dataset.bmhPremiumMotionInitialized) return;
  main.dataset.bmhPremiumMotionInitialized = 'true';
  main.dataset.bmhMotionInitialized = 'stable';
  main.dataset.bmhMotionEnabled = 'false';

  const root = document.documentElement;
  const nativeHeroEntry = root.hasAttribute('data-bmh-product-motion');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 899px)');
  const connection = navigator.connection;
  const lifecycle = new AbortController();
  const states = new Map();
  let known = new WeakSet();
  let observer;
  let mutationObserver;
  let collectFrame = 0;
  let launchFrame = 0;
  let launchNextFrame = 0;
  let enabled = false;
  let duration = 950;
  let galleryDuration = 1100;
  let stagger = 110;
  let triggerPosition = 105;
  let initial = true;

  const selectors = [
    '.bmh-dayflow__intro', '.bmh-dayflow__copy--desktop',
    '.bmh-soundscape__intro', '.bmh-soundscape__player', '.bmh-soundscape__library',
    '[class*="bmh-social__header-"]', '[class*="bmh-social__summary-"]',
    '[class*="bmh-social__review-body-"]',
    '.bmh-everyday-v2__intro', '.bmh-everyday-v2__benefit',
    '.bmh-science-compact__intro', '.bmh-science-compact__principle', '.bmh-science-compact__note',
    '.bmh-section-head', '.bmh-faq-group h3', '.bmh-faq-group details',
    '.bmh-refined-close__copy', '[class*="bmh-trust-mini__heading-"]',
    '[class*="ai-video-features__heading-"]', '[class*="ai-video-features__features-"]',
    '[id$="__bmh_product_description"] .text-block', '#seccion-seguridad a',
    '.product-card', 'product-card', 'h2'
  ].join(',');

  const number = (value, fallback, min, max) => {
    const parsed = value == null || value === '' ? fallback : Number(value);
    return Math.min(max, Math.max(min, Number.isFinite(parsed) ? parsed : fallback));
  };

  const finish = (element) => {
    const state = states.get(element);
    if (state) {
      clearTimeout(state.timer);
    }
    observer?.unobserve(element);
    states.delete(element);
    known.add(element);
    element.dataset.bmhMotionState = 'done';
    element.style.removeProperty('--bmh-item-delay');
  };

  const show = (element, delay = 0) => {
    const state = states.get(element);
    if (!state || state.showing) return;
    if (!enabled || element.contains(document.activeElement)) {
      finish(element);
      return;
    }
    // Leave upcoming items pending while the tab is in the background.
    if (document.hidden) return;
    state.showing = true;
    observer?.unobserve(element);
    element.style.setProperty('--bmh-item-delay', `${Math.min(360, delay)}ms`);
    element.dataset.bmhMotionState = 'showing';
    state.timer = setTimeout(() => finish(element), (state.gallery ? galleryDuration : duration) + Math.min(360, delay) + 100);
  };

  const showWave = (elements) => {
    const groups = new Map();
    elements.forEach((element) => {
      const state = states.get(element);
      if (!state || state.showing) return;
      const group = element.closest('.shopify-section') || main;
      const index = groups.get(group) || 0;
      groups.set(group, index + 1);
      show(element, initial && state.hero ? state.delay : index * stagger);
    });
  };

  const available = (element) => element instanceof HTMLElement &&
    !element.matches('script, style, template, [hidden]') &&
    !element.closest('[hidden], [inert], [data-dayflow-clone]') &&
    element.getBoundingClientRect().height > 0;

  const effectFor = (element) => {
    if (element.matches('[class*="bmh-trust__item-"], .bmh-faq-group details')) return 'fade';
    if (element.matches('.bmh-everyday-v2__benefit, [class*="bmh-social__summary-"]')) return 'slide';
    if (element.matches('.bmh-science-compact__principle, .product-card, product-card')) return 'settle';
    return 'lift';
  };

  const prepare = (element, options, ready) => {
    if (known.has(element) || states.has(element) || !available(element)) return;
    if (element.dataset.bmhMotionState === 'done' || !enabled || options.immediate) {
      finish(element);
      return;
    }
    const rect = element.getBoundingClientRect();
    if (rect.bottom <= 0) {
      finish(element);
      return;
    }
    element.dataset.bmhMotionKind = options.gallery ? 'gallery' : 'item';
    element.dataset.bmhMotionEffect = options.gallery ? 'gallery' : effectFor(element);
    if (rect.top < (window.innerHeight || root.clientHeight)) {
      if (initial && nativeHeroEntry && options.hero) {
        const state = { gallery: Boolean(options.gallery), hero: true, native: true, showing: true };
        states.set(element, state);
        element.dataset.bmhMotionState = 'native';
        state.timer = setTimeout(() => finish(element), duration + 460);
      } else {
        finish(element);
      }
      return;
    }
    if (element.dataset.bmhMotionEffect === 'slide') {
      const siblings = Array.from(element.parentElement?.children || []).filter((item) => item.matches('.bmh-everyday-v2__benefit'));
      element.style.setProperty('--bmh-motion-direction', siblings.indexOf(element) % 2 === 1 ? '1' : '-1');
    }
    element.dataset.bmhMotionState = 'pending';
    const state = { gallery: Boolean(options.gallery), hero: Boolean(options.hero), delay: options.delay || 0 };
    states.set(element, state);
    const edge = (window.innerHeight || document.documentElement.clientHeight) * (options.hero ? 1 : triggerPosition / 100);
    if (rect.top < edge) ready.push(element);
    else observer?.observe(element);
  };

  const collect = (immediate = false) => {
    states.forEach((state, element) => {
      if (!element.isConnected) finish(element);
    });
    const ready = [];
    main.querySelectorAll('.product-information__media').forEach((element) => {
      prepare(element, { gallery: true, hero: true, delay: 30, immediate }, ready);
    });
    const content = main.querySelector('.product-details > .group-block > .group-block-content');
    let heroIndex = 0;
    Array.from(content?.children || []).forEach((element) => {
      if (known.has(element) || states.has(element) || !available(element)) return;
      const pieces = element.querySelectorAll('[class*="bmh-price-v14__block-"], [class*="bmh-trust__item-"]');
      const items = !nativeHeroEntry && pieces.length ? Array.from(pieces) : [element];
      items.forEach((item) => {
        prepare(item, { hero: true, delay: Math.min(360, 65 + heroIndex * 55), immediate }, ready);
        heroIndex += 1;
      });
    });
    main.querySelectorAll(selectors).forEach((element) => {
      if (element.closest('.product-information, [data-bmh-dawn], [data-dayflow-clone]') ||
          element.querySelector('iframe, video') ||
          element.parentElement?.closest('[data-bmh-motion-state]')) return;
      prepare(element, { immediate }, ready);
    });
    root.dataset.bmhProductMotion = enabled ? 'ready' : 'fallback';
    if (!states.size || document.hidden) return;
    cancelAnimationFrame(launchFrame);
    cancelAnimationFrame(launchNextFrame);
    launchFrame = requestAnimationFrame(() => {
      launchNextFrame = requestAnimationFrame(() => {
        if (document.hidden) return;
        if (nativeHeroEntry) main.removeAttribute('data-bmh-sunrise-replay');
        showWave(Array.from(states.keys()).filter((element) => {
          const state = states.get(element);
          if (state.showing) return false;
          const rect = element.getBoundingClientRect();
          const edge = (window.innerHeight || root.clientHeight) * (state.hero ? 1 : triggerPosition / 100);
          return rect.top < edge && rect.bottom > 0;
        }));
        initial = false;
      });
    });
  };

  const refresh = (immediate = false) => {
    observer?.disconnect();
    const source = main.querySelector('[data-bmh-motion-config]');
    enabled = source?.dataset.enabled !== 'false' && !reduced.matches && !connection?.saveData && 'IntersectionObserver' in window;
    main.dataset.bmhPremiumMotion = String(enabled);
    if (!enabled && nativeHeroEntry) main.removeAttribute('data-bmh-sunrise-replay');
    duration = number(source?.dataset.duration, 850, 350, mobile.matches ? 650 : 950);
    galleryDuration = number(source?.dataset.galleryDuration, 900, 450, mobile.matches ? 750 : 1100);
    stagger = number(source?.dataset.stagger, 110, 50, 200);
    const distance = number(source?.dataset.distance, 12, 0, mobile.matches ? 8 : 16);
    main.style.setProperty('--bmh-motion-duration', `${duration}ms`);
    main.style.setProperty('--bmh-gallery-entry-duration', `${galleryDuration}ms`);
    main.style.setProperty('--bmh-motion-distance', `${distance}px`);
    main.style.setProperty('--bmh-gallery-entry-distance', `${distance ? (mobile.matches ? 22 : 32) : 0}px`);
    main.style.setProperty('--bmh-gallery-entry-scale', distance ? (mobile.matches ? '1.025' : '1.045') : '1');
    if (!enabled || immediate) Array.from(states.keys()).forEach(finish);
    if (enabled) {
      triggerPosition = number(mobile.matches ? source?.dataset.mobileTrigger : source?.dataset.trigger, 96, 20, 100);
      const bottom = Math.round((window.innerHeight || document.documentElement.clientHeight) * (triggerPosition / 100 - 1));
      observer = new IntersectionObserver((entries) => {
        if (document.hidden) return;
        entries.filter((entry) => entry.boundingClientRect.bottom <= 0).forEach((entry) => finish(entry.target));
        showWave(entries.filter((entry) => entry.isIntersecting).map((entry) => entry.target));
      }, { threshold: 0, rootMargin: `0px 0px ${bottom}px 0px` });
      states.forEach((state, element) => {
        if (!state.showing) observer.observe(element);
      });
    }
    collect(immediate);
  };

  const scheduleCollect = () => {
    if (collectFrame) return;
    collectFrame = requestAnimationFrame(() => {
      collectFrame = 0;
      collect();
    });
  };

  main.addEventListener('focusin', (event) => {
    const element = event.target.closest?.('[data-bmh-motion-state]');
    if (element?.matches('product-card, .product-card') && !event.target.matches?.(':focus-visible')) return;
    if (element) finish(element);
  }, { signal: lifecycle.signal });
  main.addEventListener('pointerdown', (event) => {
    const element = event.target.closest?.('[data-bmh-motion-state]');
    if (element?.matches('product-card, .product-card')) return;
    if (element) finish(element);
  }, { passive: true, signal: lifecycle.signal });
  main.addEventListener('transitionend', (event) => {
    if (event.propertyName === 'opacity' && states.get(event.target)?.showing) finish(event.target);
  }, { signal: lifecycle.signal });
  document.addEventListener('variant:update', () => collect(true), { signal: lifecycle.signal });
  document.addEventListener('shopify:section:load', () => refresh(), { signal: lifecycle.signal });
  document.addEventListener('shopify:section:unload', scheduleCollect, { signal: lifecycle.signal });
  document.addEventListener('shopify:section:select', (event) => {
    event.target.querySelectorAll?.('[data-bmh-motion-state]').forEach(finish);
  }, { signal: lifecycle.signal });
  document.addEventListener('bmh:motion:preview', () => {
    Array.from(states.keys()).forEach(finish);
    main.querySelectorAll('[data-bmh-motion-state]').forEach((element) => {
      element.removeAttribute('data-bmh-motion-state');
      element.removeAttribute('data-bmh-motion-start');
    });
    known = new WeakSet();
    initial = true;
    if (nativeHeroEntry && enabled) main.dataset.bmhSunriseReplay = 'pending';
    refresh();
  }, { signal: lifecycle.signal });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) {
      if (nativeHeroEntry) main.removeAttribute('data-bmh-sunrise-replay');
      states.forEach((state, element) => { if (state.showing) finish(element); });
    } else {
      refresh();
    }
  }, { signal: lifecycle.signal });
  reduced.addEventListener('change', () => refresh(), { signal: lifecycle.signal });
  mobile.addEventListener('change', () => refresh(), { signal: lifecycle.signal });
  connection?.addEventListener?.('change', () => refresh(), { signal: lifecycle.signal });
  window.addEventListener('resize', scheduleCollect, { passive: true, signal: lifecycle.signal });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) refresh();
  }, { signal: lifecycle.signal });
  window.addEventListener('pagehide', (event) => {
    if (nativeHeroEntry) main.removeAttribute('data-bmh-sunrise-replay');
    states.forEach((state, element) => {
      if (!event.persisted || state.showing) finish(element);
    });
    if (!event.persisted) {
      observer?.disconnect();
      mutationObserver?.disconnect();
      cancelAnimationFrame(collectFrame);
      cancelAnimationFrame(launchFrame);
      cancelAnimationFrame(launchNextFrame);
      lifecycle.abort();
    }
  }, { signal: lifecycle.signal });

  refresh();
  mutationObserver = new MutationObserver((records) => {
    const relevant = `${selectors}, .product-information, .product-information__media, .product-details`;
    if (records.some((record) => Array.from(record.addedNodes).some((node) =>
      node.nodeType === 1 && !node.closest('slideshow-component, zoom-dialog, [data-dayflow-clone]') &&
      (node.matches(relevant) || node.querySelector(relevant))
    ))) scheduleCollect();
  });
  mutationObserver.observe(main, { childList: true, subtree: true });
})();

